
const mobileCheckbox = document.getElementById('mobile-menu-toggle');

if (mobileCheckbox) {

    let active = 'mobile-menu-active'
    let { classList: c } = document.body

    mobileCheckbox.addEventListener('change', e => e.target.checked ? c.add(active) : c.remove(active));

} else {
    console.warn('Menu toggle missing. Can\'t update the body style without this element state.')
}